module.exports = __webpack_public_path__ + "img/playImage.31e72a69.png";